import { watch } from 'vue'
import { SUB_NAV_COLLAPSED_STORAGE_KEY } from '~/utils/dashboard-sidebar-state'

/** 二级菜单 icon 轨收起态（sessionStorage 持久化） */
export function useDashboardSubNavCollapsed() {
  const subNavCollapsed = useState('lip-sub-nav-collapsed', () => false)

  if (import.meta.client) {
    try {
      const stored = sessionStorage.getItem(SUB_NAV_COLLAPSED_STORAGE_KEY)
      if (stored === '1') subNavCollapsed.value = true
    } catch {
      /* private mode */
    }
  }

  watch(subNavCollapsed, (collapsed) => {
    if (!import.meta.client) return
    try {
      sessionStorage.setItem(SUB_NAV_COLLAPSED_STORAGE_KEY, collapsed ? '1' : '0')
    } catch {
      /* private mode */
    }
  })

  function toggleSubNav() {
    subNavCollapsed.value = !subNavCollapsed.value
  }

  return { subNavCollapsed, toggleSubNav }
}
